<template>
  <div
    v-if="element && element.is_hovering && user.is_admin"
    class="bg-black relative h-0"
    >
    <div class="absolute z-10 right-0 top-full w-auto content-start">
      <div
        class="bg-slate-300/30 backdrop-blur-md h-auto p-4 py-2 rounded-b-lg mb-px flex flex-wrap gap-2 items-stetch justify-start"
        @click.prevent
        >
        <ui-text
          :model-value="element.order"
          label="Order"
          class="max-w-14"
          @bounced="(e) => {
            if (!element) return
            element.order = e
            methodReorderBlogElements(modelBlog as Blog)
          }"
          />

        <ui-select v-model="element.type" class="min-w-28">
          <UiSelectOption
            v-for="available in availableElements.sort((a,b) => a.value.localeCompare(b.value))"
            :key="'available_'+available.value"
            :value="available.value.toLowerCase()"
            :text="available.value"
            />
        </ui-select>

        <div class="flex p-2 gap-2 items-center bg-white rounded-lg">
          Edit
          <ui-switch v-model="element.is_editing"/>
        </div>

        <ui-button
          class="bg-white"
          svg="fas fa-arrow-up text-blue-600"
          @click="$emit('moveup')"
          >
          <i class="fas fa-angle-up text-xs" />
        </ui-button>

        <ui-button
          class="bg-white"
          svg="fas fa-arrow-down text-blue-600"
          @click="$emit('movedown')"
          >
          <i class="fas fa-angle-down text-xs" />
        </ui-button>


        <ui-button
          class="bg-white"
          svg="fas fa-plus text-green-600"
          @click="$emit('addabove')"
          >
          <i class="fas fa-arrow-up text-xs" />
        </ui-button>

        <ui-button
          class="bg-white"
          svg="fas fa-plus text-green-600"
          @click="$emit('addbelow')"
          >
          <i class="fas fa-arrow-down text-xs" />
        </ui-button>

        <ui-button
          class="bg-white"
          svg="fas fa-trash text-red-600"
          @click="$emit('remove')"
          />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['remove','addbelow','addabove','moveup','movedown'])

const element = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')
</script>
